import { render, staticRenderFns } from "./educationMaterial.vue?vue&type=template&id=b7b60b50"
import script from "./educationMaterial.vue?vue&type=script&lang=js"
export * from "./educationMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7b60b50')) {
      api.createRecord('b7b60b50', component.options)
    } else {
      api.reload('b7b60b50', component.options)
    }
    module.hot.accept("./educationMaterial.vue?vue&type=template&id=b7b60b50", function () {
      api.rerender('b7b60b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationMaterial.vue"
export default component.exports